import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';

const _GetFirstYearDischargeRateRequestDtoSchema = z.object({
  facilityId: z.number(),
  from: z.string(),
  to: z.string(),
  comparisonSet: z.enum(['INTERNAL', 'COMP']).optional(),
});

const GetFirstYearDischargeRateResponseDtoSchema = z.object({
  marketMedian: z.number().nullable(),
  currentValue: z.number().nullable(),
  hint: z.string(),
  message: z.string(),
});

export type GetFirstYearDischargeRateRequestDto = z.infer<
  typeof _GetFirstYearDischargeRateRequestDtoSchema
>;
export type GetFirstYearDischargeRateResponseDto = z.infer<
  typeof GetFirstYearDischargeRateResponseDtoSchema
>;

export const getFirstYearDischargeRate = async (
  params: GetFirstYearDischargeRateRequestDto,
  config?: AxiosRequestConfig<GetFirstYearDischargeRateRequestDto>
) => {
  const { facilityId, ...restParams } = params;

  return api
    .get(
      `/market-intelligence/facilities/${facilityId}/first-year-discharge-rate-kpi`,
      {
        params: restParams,
        ...config,
      }
    )
    .then(responseContract(GetFirstYearDischargeRateResponseDtoSchema));
};
